import { render } from "./Lottery_winnerList.vue?vue&type=template&id=34ebd1cf"
import script from "./Lottery_winnerList.vue?vue&type=script&lang=js"
export * from "./Lottery_winnerList.vue?vue&type=script&lang=js"
script.render = render

export default script